import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { paths } from "helpers/paths";
import { isDeletedColumn, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";
import { namesList as counterpartiesList } from "sources/books/cargoOwners";
import { restore } from "sources/books/documentTemplates";

const DOCUMENT_TEMPLATE_INSTRUCTION_URL = "https://cargorun.omnidesk.ru/knowledge_base/item/367668?sid=79193";

export class DocumentTemplates extends BookIndex {
    renderHead = () => {
        return (
            <div className="book-list__head-wrap">
                <div className="book-list__head">
                    <div className="book-list__head-close close close--sm" onClick={this.close} />
                    <div className="book-list__head-title">
                        {this.props.title}
                        {this.renderCounter()}
                    </div>
                    <div className="btn-toolbar align-items-center">
                        <a
                            className="small mr-3"
                            href={DOCUMENT_TEMPLATE_INSTRUCTION_URL}
                            target="_blank"
                            rel="noreferrer"
                        >
                            Инструкция по созданию шаблонов
                        </a>
                        {this.props.canEditBooks && this.renderCreateButton()}
                    </div>
                </div>
            </div>
        );
    };

    get tableColumns() {
        const restoreAction = (id) => {
            this.props.modal({
                name: "confirm",
                title: "Вы действительно хотите восстановить?",
                action: () => restore({ id }).then(() => this.props.mergeParams({})),
                buttons: { confirm: "Да", cancel: "Нет" },
            });
        };

        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) => <Link to={paths.documentTemplatesShow(id)}>{value}</Link>,
            },
            { Header: "ID файла", accessor: "fileId", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Контрагенты",
                accessor: "counterparties",
                filterable: true,
                filterType: "select",
                isMulti: true,
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            ...defaultMultipleSelectProps,
                            inputProps: { name: "counterpartyIds" },
                            url: counterpartiesList,
                            propName: "name",
                            components: { ValueContainer },
                        }}
                    />
                ),
                Cell: ({ value }) =>
                    value?.length > 0
                        ? value.map((item) => (
                              <a className="d-block" href={paths.cargoOwnersShow(item.id)} key={item.id}>
                                  {item.name}
                              </a>
                          ))
                        : "Общий шаблон",
                CSVExport: ({ value }) =>
                    value?.length > 0 ? value.map((item) => item.name).join("; ") : "Общий шаблон",
            },
            isDeletedColumn(restoreAction, true),
        ];
    }

    renderCreateButton = () => {
        const props = {
            className: "btn btn-brand btn-sm",
            to: paths.documentTemplatesNew,
        };
        return <Link {...props}>{this.props.createBtnText}</Link>;
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(DocumentTemplates, "document-templates");
